import {
    createFilterPill,
    FILTER_PILL_ITEM_STATE_CHECKED,
    FilterPill,
    IFilterPillItem,
} from '@vfde-brix/ws10/filter-pill';
import { HardwareFacetGroup } from '@vfde-sails/glados-v2';
import {
    selectSelectedFacets,
    toggleFilter,
} from '../features/app/slice';
import { selectAvailableFacets } from '../features/app/selectors';
import {
    RootState,
    useAppDispatch,
} from '../app/store';
import { startAppListening } from '../app/listener';

/**
 * Filter Pill
 */
export const mountFilterPill = (containerId: string): FilterPill | null => {
    const container = document.getElementById(containerId);

    if (!container) {
        return null;
    }

    const dispatch = useAppDispatch();

    const filterPill = createFilterPill(container, {
        onClick: (id: string) => dispatch(toggleFilter({
            label: id,
        } as Parameters<typeof toggleFilter>[0])),
    });

    listenForUpdates(filterPill);

    return filterPill;
};

const listenForUpdates = (filterPill: FilterPill) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectAvailableFacets(currentState) !== selectAvailableFacets(previousState),
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const hasNoAvailableCategories = selectAvailableFacets(state).length === 0;

            filterPill?.toggleContainer(hasNoAvailableCategories, true);

            if (hasNoAvailableCategories) {
                return;
            }

            const filterPillItems = convertApiCategoriesToFilterPillItems(state);

            filterPill?.update({
                listFilterPillItems: filterPillItems,
            });
        },
    });
};

/**
 * Convert categories from API to filter pill properties
 */
const convertApiCategoriesToFilterPillItems = (state: RootState): IFilterPillItem[] => {
    const availableFacets = selectAvailableFacets(state);
    const selectedFacets = selectSelectedFacets(state);

    return availableFacets
        .filter(facet => facet.group === HardwareFacetGroup.Manufacturer)
        .map(facet => {
            const { label: facetLabel } = facet;
            const isSelected = selectedFacets.some(selectedFacet => selectedFacet.label === facetLabel);
            const optState = isSelected ? FILTER_PILL_ITEM_STATE_CHECKED : undefined;

            return {
                stdPillLabel: facetLabel,
                stdValue: facetLabel,
                optState,
            };
        });
};
